<div class="container">
	<div class="kop">
		<span class="titel">Kies je rol</span>
		<span class="toelichting">Dit bepaalt welke informatie en gegevens je kunt zien</span>
	</div>
	<fieldset class="rollen">
		<legend class="sr-only">Kies je rol</legend>
		@for (rol of data.rollen; track rol) {
			<label class="rol" [class.is-actief]="isActief(rol)">
				<input
					type="radio"
					name="rol"
					[checked]="isActief(rol)"
					[tabIndex]="isActief(rol) ? 0 : -1"
					(change)="kiesRol(rol)"
				/>
				<div class="rol-tekst">
					<span class="naam">{{ getRolName(rol) }}</span>
					<span class="uitleg">{{ getRolUitleg(rol) }}</span>
				</div>
				<span class="radio-bolletje"></span>
			</label>
		}
	</fieldset>
</div>
